module.exports = __webpack_public_path__ + "static/media/ic_desktop.60277e85.svg";